import React from 'react'
import Contracts from '../../Contracts'
import UnderConstruction from '../../../../components/ui/underConstruction/UnderConstruction'

const Invoices = () => {
  return (
     <UnderConstruction/>
  )
}

export default Contracts(Invoices)